import Logger from "./logger";

export default class NullLogger implements Logger {
  public log(): void {}
}
